/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Lustrace_Status_SkippedInputs */

const cs_property_lustrace_status_skipped = /** @type {(inputs: Property_Lustrace_Status_SkippedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přeskočeno`)
};

const en_property_lustrace_status_skipped = /** @type {(inputs: Property_Lustrace_Status_SkippedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skipped`)
};

/**
* | output |
* | --- |
* | "Skipped" |
*
* @param {Property_Lustrace_Status_SkippedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_lustrace_status_skipped = /** @type {((inputs?: Property_Lustrace_Status_SkippedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Lustrace_Status_SkippedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_lustrace_status_skipped(inputs)
	return cs_property_lustrace_status_skipped(inputs)
});